import React, { useEffect } from "react";
import PropTypes from "prop-types";

import FeedsSlider from "./FeedsSlider";

const PinterestFeeds = ({ t }) => {
  const feeds = ["egwwritings"];

  const preloadScript = () => {
    const script = document.createElement("script");
    script.async = true;
    script.dataset.pinBuild = "doBuild";
    script.src = "//assets.pinterest.com/js/pinit.js";
    document.body.appendChild(script);
  };

  const renderItem = ({ item }) => {
    return (
      <a data-pin-do="embedUser" data-pin-scale-width="80" href={`https://www.pinterest.com/${item}/`} />
    );
  };

  useEffect(() => {
    if (!window.doBuild) {
      preloadScript();
    } else {
      window.doBuild();
    }
  }, []);

  return (
    <FeedsSlider renderItem={renderItem} records={feeds} containerClassName="pinterest-feeds">
      <h3 className="feeds-header">
        {t("follow_us_on")}
        <a
          href="https://www.pinterest.com/egwwritings/"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          {t("pinterest")}
        </a>
      </h3>
    </FeedsSlider>
  );
};

PinterestFeeds.propTypes = {
  t: PropTypes.func.isRequired
};

export default PinterestFeeds;
